<template>
  <div id="app" class="siimple-content--medium animated fadeIn faster">
    <div id="logo">
      <a href="/"><img src="/static/NN_Logo_Stor_RGB.jpg"/></a>
    </div>
    <div id="easteregg">
      <img src="/static/easteregg.png" />
    </div>
    <div class="siimple-jumbotron siimple-jumbotron--fluid" align="center">
      <div class="siimple-jumbotron-subtitle">🌟🕸️ 🐣🌰🥜</div>
      <div class="siimple-jumbotron-title">NOVANETS PÅSKENØTTER</div>
      <div class="siimple-jumbotron-detail">
        <router-link class="siimple-link" to="/oppgaver">Oppgaver</router-link>
        |
        <router-link class="siimple-link" to="/highscores"
          >Highscore</router-link
        >
        |
        <!-- <router-link class="siimple-link" to="/statistics"
          >Statistikk</router-link
        > -->
        <!-- TODO: Commented when competition is running -->
        <router-link class="siimple-link" to="/solutions">Fasit</router-link>
      </div>
    </div>
    <div
      v-if="displayWarning"
      class="siimple-alert siimple-alert--warning siimple--mt-3"
      align="left"
    >
      <div class="siimple-alert-close" @click="displayWarning = false" />
      <div class="siimple-alert-title">Novanets påskenøtter er avsluttet for denne gang 🎉</div>
      Blant 26 deltakere med alt riktig, ble <strong>Julian</strong> trukket som heldig vinner. Gratulerer!
      Highscore og statistikk er nå låst, men du kan fortsatt løse oppgavene om
      du vil. Eller se
      <router-link class="siimple-link" to="/solutions">fasit</router-link> her.
    </div>
    <router-view />
    <div class="siimple-footer" align="center">
      Konkurransen varer til 1. april 2024. Følg Novanet på
      <a
        href="https://www.instagram.com/novanetas/"
        class="siimple-link"
        target="_blank"
        >instagram</a
      >,
      <a
        href="https://www.facebook.com/novanet.no"
        class="siimple-link"
        target="_blank"
        >facebook</a
      >
      og
      <a
        href="https://www.linkedin.com/company/novanet-as/"
        class="siimple-link"
        target="_blank"
        >linkedin</a
      >
      <div>
        Klager og bestikkelser kan sendes til
        <a class="siimple-link" href="mailto:philip.lodding@novanet.no">Philip Lodding</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      displayWarning: true // Set to 'true' when competition has ended
    };
  }
};
</script>

<style scoped>
.siimple-jumbotron {
  padding-top: 70px;
  padding-bottom: 60px;
}
@media (min-width: 480px) {
  .siimple-content--medium {
      max-width: 1000px;
      padding-left: calc(50% - 1000px / 2);
      padding-right: calc(50% - 1000px / 2);
  }
}
</style>

<style>
body {
  background-color: #e7f5f2;
}

#app {
  color: #333132;
}

#logo {
  position: fixed;
  top: 15px;
  left: 15px;
}

#logo img {
  height: 8vh;
}

#easteregg {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.siimple-jumbotron-title {
  margin-top: 2vh;
  margin-bottom: 2vh;
}

.siimple-h2 {
  color: #333132;
}

.siimple-h5 {
  color: #333132;
}

.siimple-link {
  color: #333132;
  text-decoration: underline;
}

.siimple-table-cell {
  color: #333132;
}

.siimple-table-header .siimple-table-cell {
  border-bottom: 1px solid #50e3c2;
}

.siimple-table--striped
  .siimple-table-body
  .siimple-table-row:nth-child(odd)
  .siimple-table-cell {
  background-color: #333132;
}

.siimple-input {
  border: 1px solid #333132;
  background-color: #fff;
}

/* Make sure all input fields are at least 16px on mobile due to ios autozoom feature */
@media (max-width: 480px) {
  .siimple-input {
    font-size: 16px;
  }

  #logo {
    position: relative;
    left: 0px;
  }

  #logo img {
    max-height: 5vh;
  }

  #easteregg {
    display: none;
  }
}

@media (max-width: 1200px) {
  #easteregg {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue